import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
import ViewRequisition from "../pages/ViewRequisition";
import RequestsHistory from "../pages/RequestsHistory";

const RequisitionManagement = lazy(() =>import("../pages/RequisitionManagement"));
const NewJobRequistion=lazy(()=>import('../pages/NewJobRequistion'))
import ViewRequestModification from "../pages/ViewRequestModification";
export const jobRequisitionRoutes = [
  {
    path: "/job-requisition",
   
     children: [
       {
         path: "",
         element: (
           <Suspense fallback={<LoadingFeedback />}>
             <RequisitionManagement />
           </Suspense>
         ),
         
       },
       {
        path: "new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <NewJobRequistion />
          </Suspense>
        ),
        
      },

       {
        path: ":id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ViewRequisition />
          </Suspense>
        ),
      },
      {
        path: "history",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <RequestsHistory />
          </Suspense>
        ),
      },
      // =========
      {
        path: ":id/modification/:id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ViewRequestModification />
          </Suspense>
        ),
      }
     ]
  },
];
